import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { HistoryInactivateUserConfigService } from './shared/history_inactive_user-config.services';
import { HistoryInactivateUserDataService } from './shared/history_inactivate_user-data.services';
import { DatePipe } from '@angular/common';


@Component ({
    selector: 'iw-history-users-inactivation',
    templateUrl: './history-users-inactivation.component.html',
    styleUrls: ['./history-users-inactivation.component.scss'],
    providers: [HistoryInactivateUserConfigService, HistoryInactivateUserDataService, DatePipe]
})
export class HistoryUsersInactivationComponent implements OnInit {

  // para poder realizar el filtro general
  source: LocalDataSource;
  sourceModal: LocalDataSource;
  // variable donde se configura las opciones de la tabla
  settings = {};

  constructor(
    private hiuds: HistoryInactivateUserDataService,
    public datePipe: DatePipe,
  ) {}

  ngOnInit() {
    const configTable = new HistoryInactivateUserConfigService();
    this.settings = configTable.settings;
    //Obtiene el historial de inactivaciones
    this.getAllHistoryInactivations();
  }

  getAllHistoryInactivations(){
    let dataHistory: any[] = [];
    this.hiuds.getHistoryInactivationUsers().then(res => {
      res.forEach(data => {
        dataHistory.push({
          id: data.id,
          funcionario : data.identificacion + '-' + data.nombre + ' ' + data.apellido,
          motivo: data.motivo.nombre,
          fecha_inicial: this.datePipe.transform(data.fecha_inicial, 'dd-MM-yyyy'),
          fecha_final: this.datePipe.transform(data.fecha_final, 'dd-MM-yyyy')
        })
      });
      this.source = new LocalDataSource(dataHistory);
      this.source.refresh();
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/system-users-inactivation/history-inactivation-users/history-users-inactivation.component.ts